import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  makeStyles,
  Select,
  MenuItem,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  withStyles,
  TablePagination,
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
  IconButton,
  Input,
  InputAdornment,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { withRouter } from "react-router-dom";
import {
  getDegree,
  getDegreeCourse,
  clearData,
  clearErrorMessage,
  clearErrorStatusCode,
} from "../../../reduxSlices/degreeSlice";
import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop/";
import Aux from "../../../hoc/Auxilliary";
import MessageIndicator from "../../SnackBar";
import localizedStrings from "../../../utils/localize";
import {
  getApplicantStatus,
  getOptionList,
} from "../../../reduxSlices/applicationSlice";
import '../DegreePlan/ckeditor-content.css';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 168,
    color: "white",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  "MuiAppBar-root": {
    zIndex: "98",
  },
  degreeFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    padding:"22px 0 0 0",
  },
  degreeFont1: {
    fontSize: "1.2rem",
    fontWeight: 500,
    padding:"22px 0 0 0",
  },
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  searchInput: {
    color: "white",
    "& .MuiInputBase-input": {
      paddingLeft: "0.25rem",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "rgba(255,255,255,0.5)",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: "#ffffff",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#ffffff",
    },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const DegreePlan = (props) => {
  const dispatch = useDispatch();
  const [degree, setDegree] = useState([]);
  const [studentId, setStudentId] = useState(undefined);
  const [tableMapData, setTableMapData] = useState([]);
  const [groupCourses, setGroupCourses] = useState([]);
  const [programDescription, setProgramDescription] = useState([]);
  const [value, setValue] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const classes = useStyles();
  const [selectedDegree, setSelectedDegree] = useState("");
  const [certificationProgramid, setCertificationProgramid] = useState(null);
  const [courseFilter, setCourseFilter] = useState("");
  const [termFilter, setTermFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [groupCourseFilter, setGroupCourseFilter] = useState("");
  const [groupTermFilter, setGroupTermFilter] = useState("");
  const [groupStatusFilter, setGroupStatusFilter] = useState("");
  const statusesData = statusFilter;
  
  const [defaultSelectedDegreeId, setDefaultSelectedDegreeId] = useState("");
  const [displayMessage, setDisplayMessage] = useState("");
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [expanded, setExpanded] = useState({});
  const degreeData = useSelector((state) => state.degreeData.degree);
  const studentcanviewegreeplan = useSelector(
    (state) => state.degreeData.studentcanviewegreeplan,
  );
  const degreeCoursesData = useSelector(
    (state) => state.degreeData.degreeCourses,
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  const errorMessage = useSelector((state) => state.degreeData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.degreeData.errorStatusCode,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.degreeData.dataFetchingStatus,
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
  }, [dispatch]);

  useEffect(() => {
    const entity = "ses_studentrequiredcourse";
    const attributename = "ses_studentsessionstatus";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  const funcOptionList = (status) => {
    let value;
    if (optionList?.length !== 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
        return null;
      });
    }
    return value;
  };

  const getLocalizedStatusLabel = (status) => {
    const label = funcOptionList(status);
    if (!label) {
      return "";
    }

    if (language === "fr") {
      const normalizedLabel = label.trim().toLowerCase();
      if (normalizedLabel === "completed") {
        return localizedStrings.students.degreePlan.completed || "Complété";
      }
      if (normalizedLabel === "enrolled") {
        return localizedStrings.general.StatusEnrolled || "Inscrit";
      }
    }

    return label;
  };

  const translateCreditType = (creditType) => {
    if (!creditType) return "";
    const creditTypeStr = creditType.toString();
    if (creditTypeStr === "Earned Credits") {
      return localizedStrings.students.degreePlan.earnedCredits;
    }
    if (creditTypeStr === "Transfer Credits") {
      return localizedStrings.students.degreePlan.transferCredits;
    }
    if (creditTypeStr === "Completed") {
      return localizedStrings.students.degreePlan.completed;
    }
    return creditType;
  };

  useEffect(() => {
    if (degreeCoursesData?.requiredCourses?.length === 0) {
      setTableMapData([]);
      setCourseFilter("");
      setStatusFilter("");
      setTermFilter("");
    }
    if (degreeCoursesData?.groupCourses?.length === 0) {
      setGroupCourses([]);
      setCourseFilter("");
      setStatusFilter("");
      setGroupCourseFilter("");
      setGroupStatusFilter("");
      setGroupTermFilter("");
    }
    if (
      degreeCoursesData.requiredCourses &&
      degreeCoursesData.requiredCourses.length
    ) {
      let degreeCourses = [...degreeCoursesData?.requiredCourses];
      setTableMapData(
        degreeCourses.sort(
          (a, b) => parseFloat(a.ses_order) - parseFloat(b.ses_order),
        ),
      );
    }
    if (
      degreeCoursesData.groupCourses &&
      degreeCoursesData.groupCourses.length > 0
    ) {
      let groupCourses = degreeCoursesData.groupCourses;
    
      // Filter out empty course objects
      groupCourses = groupCourses.map((courseGroup) => ({
        ...courseGroup,
        data: courseGroup?.data?.filter(
          (course) => Object.keys(course).length > 0
        ),
      }));
    
      // Sort by ses_order (as number) in ascending order
      groupCourses.sort((a, b) => {
        const orderA = parseInt(a?.ses_order || '0', 10);
        const orderB = parseInt(b?.ses_order || '0', 10);
        return orderA - orderB;
      });
    
      setGroupCourses(groupCourses);
    }
    if (degreeCoursesData?.programDescription?.length > 0) {
      setProgramDescription(degreeCoursesData.programDescription);
    }
  }, [degreeCoursesData, selectedDegree]);

  useEffect(() => {
    if (degreeData && degreeData?.length > 0) {
      const sortDegree = degreeData
        ?.slice()
        .sort((a, b) =>
          a.ses_certificationprogramname.localeCompare(
            b.ses_certificationprogramname,
          ),
        );
      setDegree(sortDegree);

if(sortDegree.length > 0){
      const programId = sortDegree?.filter(v => v != null)
      .filter(
        (v) =>
          v.ses_degreeplanid ===
          studentcanviewegreeplan[0]?._usb_primarydegreeplan_value,
      );

      if (studentcanviewegreeplan.length > 0) {
        setSelectedDegree(
          studentcanviewegreeplan[0]?._usb_primarydegreeplan_value,
        );
        setDefaultSelectedDegreeId(
          studentcanviewegreeplan[0]?._usb_primarydegreeplan_value,
        );
        setCertificationProgramid(programId[0]?._ses_certificationprogramid_value)
      }
    }
    }
  }, [degreeData, studentcanviewegreeplan]);

  useEffect(() => {
    if (applicantStatus.ses_applicantstatus) {
      setStudentId(applicantStatus.ses_applicantstatus.ses_studentid);
      dispatch(getDegree(applicantStatus.ses_applicantstatus.ses_studentid));
    }
  }, [applicantStatus]);

  useEffect(() => {
    if (selectedDegree && studentId) {
      dispatch(getDegreeCourse({ degreeId: selectedDegree, studentId,certificationProgramid }));
    }
  }, [selectedDegree]);

  // Reset to Description tab (index 0) when degree is selected or changed
  useEffect(() => {
    if (selectedDegree) {
      setValue(0);
    }
  }, [selectedDegree]);
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);
  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };
  useEffect(() => {
    return () => {
      dispatch(clearData());
    };
  }, []);
  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCourseFilter("");
    setStatusFilter("");
    setGroupCourseFilter("");
    setGroupStatusFilter("");
    setPage(0);
  };


  const handleChangeFilter = (event) => {
    const { name, value } = event.target;
    if (name === "course") {
      setCourseFilter(value);
      setPage(0);
    }

    if (name === "status") {
      setStatusFilter(value);
      setPage(0);
    }

    if (name === "term") {
      setTermFilter(value);
      setPage(0);
    }
  };

  const handleGroupFilterChange = (event) => {
    const { name, value } = event.target;
    if (name === "groupCourse") {
      setGroupCourseFilter(value);
    }

    if (name === "groupStatus") {
      setGroupStatusFilter(value);
    }

    if (name === "groupTerm") {
      setGroupTermFilter(value);
    }
  };

  // Get unique status values for filter dropdown
  const getStatusData = () => {
    const statusSet = new Set();
    tableMapData.forEach((course) => {
      if (course.ses_studentsessionstatus !== undefined && course.ses_studentsessionstatus !== null) {
        statusSet.add(course.ses_studentsessionstatus);
      }
    });
    return Array.from(statusSet).map((statusValue) => (
      <MenuItem value={statusValue} key={statusValue}>
        {getLocalizedStatusLabel(statusValue)}
      </MenuItem>
    ));
  };

  // Filter table data based on filters
  const getFilteredData = () => {
    let filtered = [...tableMapData];
    
    if (courseFilter) {
      const filterLower = courseFilter.toLowerCase();
      filtered = filtered.filter((course) => {
        const courseCode = (course.ses_course || "").toLowerCase();
        const courseName = (course.ses_coursename || "").toLowerCase();
        const combined = `${course.ses_course || ""} - ${course.ses_coursename || ""}`.toLowerCase();
        return (
          courseCode.includes(filterLower) ||
          courseName.includes(filterLower) ||
          combined.includes(filterLower)
        );
      });
    }

    if (termFilter) {
      const termLower = termFilter.toLowerCase();
      filtered = filtered.filter((course) => {
        const term =
          (
            course[
              "_ses_term_value@OData.Community.Display.V1.FormattedValue"
            ] || ""
          ).toLowerCase();
        return term === termLower;
      });
    }
    
    if (statusFilter) {
      filtered = filtered.filter((course) => {
        return course.ses_studentsessionstatus === parseInt(statusFilter);
      });
    }
    
    return filtered;
  };

  const filteredTableData = getFilteredData();
  const statusData = getStatusData();
  const getTermOptions = () => {
    const termSet = new Set();
    tableMapData.forEach((course) => {
      const term =
        course["_ses_term_value@OData.Community.Display.V1.FormattedValue"];
      if (term) termSet.add(term);
    });
    return Array.from(termSet).map((term) => (
      <MenuItem value={term} key={`term-${term}`}>
        {term}
      </MenuItem>
    ));
  };
  const groupStatusOptions = () => {
    const statusSet = new Set();
    groupCourses.forEach((courseGroup) => {
      courseGroup?.data?.forEach((course) => {
        if (
          course.ses_studentsessionstatus !== undefined &&
          course.ses_studentsessionstatus !== null
        ) {
          statusSet.add(course.ses_studentsessionstatus);
        }
      });
    });

    return Array.from(statusSet).map((statusValue) => (
      <MenuItem value={statusValue} key={`group-${statusValue}`}>
        {getLocalizedStatusLabel(statusValue)}
      </MenuItem>
    ));
  };

  const getFilteredGroupData = (courseGroup) => {
    let filtered = [...(courseGroup?.data || [])];

    if (groupCourseFilter) {
      const filterLower = groupCourseFilter.toLowerCase();
      filtered = filtered.filter((course) => {
        const courseCode = (course.ses_course || "").toLowerCase();
        const courseName = (course.ses_coursename || "").toLowerCase();
        const combined = `${course.ses_course || ""} - ${course.ses_coursename || ""}`.toLowerCase();
        return (
          courseCode.includes(filterLower) ||
          courseName.includes(filterLower) ||
          combined.includes(filterLower)
        );
      });
    }

    if (groupStatusFilter) {
      filtered = filtered.filter((course) => {
        return course.ses_studentsessionstatus === parseInt(groupStatusFilter);
      });
    }

    if (groupTermFilter) {
      const termLower = groupTermFilter.toLowerCase();
      filtered = filtered.filter((course) => {
        const term =
          (
            course[
              "_ses_term_value@OData.Community.Display.V1.FormattedValue"
            ] || ""
          ).toLowerCase();
        return term === termLower;
      });
    }

    return filtered;
  };

  let tableData = "";
  if (filteredTableData.length > 0) {
    tableData = filteredTableData
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((degreeCourse) => {
        return (
          <StyledTableRow>
            <StyledTableCell align="left">
              {degreeCourse.ses_course} - {degreeCourse.ses_coursename}
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse["_ses_term_value@OData.Community.Display.V1.FormattedValue"] || ""}
            </StyledTableCell>
            <StyledTableCell align="left">
              {getLocalizedStatusLabel(degreeCourse.ses_studentsessionstatus)}
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse["ses_gradereceived"]}
            </StyledTableCell>
            <StyledTableCell align="left">
              {
                degreeCourse[
                  "ses_creditsavailable@OData.Community.Display.V1.FormattedValue"
                ]
              }
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse["ses_earnedcredits"] === undefined
                ? ""
                : parseFloat(degreeCourse["ses_earnedcredits"]) === 0
                  ? degreeCourse[
                      "ses_earnedcredits@OData.Community.Display.V1.FormattedValue"
                    ]
                  : degreeCourse["ses_requirementmet"] === true
                    ? degreeCourse[
                        "ses_earnedcredits@OData.Community.Display.V1.FormattedValue"
                      ]
                    : "-"}
            </StyledTableCell>
            <StyledTableCell align="left">
              {translateCreditType(
                degreeCourse[
                  "ses_credittype@OData.Community.Display.V1.FormattedValue"
                ]
              )}
            </StyledTableCell>
          </StyledTableRow>
        );
      });
  }

  useEffect(() => {
    if (error.message === "student id is required") {
      setDisplayMessage(localizedStrings.general.studentiderrorMessage);
    } else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(error.message);
    }
  }, [error]);

  // Custom label for the "of" keyword in TablePagination
  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };
  const handleChangeDegreePlan = (event) => {
    setSelectedDegree(event.target.value);
  };

  const toggleExpand = (courseGroupName) => {
    setExpanded((prev) => ({
      ...prev,
      [courseGroupName]: !prev[courseGroupName],
    }));
  };

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />

      <div style={{display: "inline"}}>
     <div component="div" className={classes.degreeFont}>
          {localizedStrings.students.degreePlan.myDegreePlan}
        </div>

     {degree?.length === 0 || degree?.[0] == null ? (
  <div component="div" className={classes.degreeFont1}>
    <br/>  <br/>
    {localizedStrings.students.degreePlan.degreeplanNotFound}
  </div>
) : null}
        
        <br/>
{degree?.length > 0 && degree?.[0] != null && (
        <div>
      {studentcanviewegreeplan?.length > 0 &&
        !studentcanviewegreeplan[0]?.usb_canviewdegreeplan && (
          <div
            style={{
              margin: "2rem 0 23rem 0",
              fontSize: "16px",
            }}
          >
            {localizedStrings.students.degreePlan.canviewegreeplan}
          </div>
        )}

      {studentcanviewegreeplan?.length > 0 &&
        studentcanviewegreeplan[0]?.usb_canviewdegreeplan && (
          <>
            <FormControl className={classes.formControl}>jhjgjghj
              <InputLabel id="degree-plan">
                {localizedStrings.students.degreePlan.degreePlan}
              </InputLabel>
              <Select
                labelId="degree-plan"
                id="degree-plan"
                value={selectedDegree}
                defaultValue={defaultSelectedDegreeId}
                disabled={degree.length === 0}
                onChange={handleChangeDegreePlan}
              >
                <MenuItem value="" style={{ display: "none" }}></MenuItem>

                {degree.map((data) => (
                  <MenuItem
                    key={data?.ses_degreeplanid}
                    value={data?.ses_degreeplanid}
                  >
                    {data?.ses_certificationprogramname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <AppBar
              position="static"
              classes={{ root: classes["MuiAppBar-root"] }}
            >
              <Tabs value={value} onChange={handleChange} aria-label="courses">
                <Tab
                  label={
                    localizedStrings.students.degreePlan.programDescription
                  }
                  disabled={!selectedDegree || dataFetchingStatus}
                  {...a11yProps(0)}
                />
                <Tab
                  label={
                    localizedStrings.students.degreePlan.requireddegreecourses
                  }
                  {...a11yProps(1)}
                />
                <Tab
                  label={
                    localizedStrings.students.degreePlan.degreecoursegroups
                  }
                  disabled={!selectedDegree || dataFetchingStatus}
                  {...a11yProps(2)}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              {programDescription.length > 0 && (
                <>
                  <div
                  className="ck-content"
                    dangerouslySetInnerHTML={{
                      __html: programDescription[0].ses_programdescription,
                    }}
                  />
                </>
              )}
            </TabPanel>
            <TabPanel value={value} index={1}>
              <TableContainer
                component={Paper}
                style={{ minHeight: "46.5vh", marginBottom: "10px" }}
              >
                <Table aria-label="required degree course">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="left">
                        <div className={classes.TableControl}>
                          {localizedStrings.students.degreePlan.course}
                          <Input
                            value={courseFilter}
                            onChange={handleChangeFilter}
                            className={`${classes.formControl} ${classes.searchInput}`}
                            displayEmpty
                            name="course"
                            startAdornment={
                              <InputAdornment position="start">
                                <SearchIcon style={{ color: "#ffffff" }} />
                              </InputAdornment>
                            }
                          />
                        </div>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <div className={classes.TableControl}>
                          Session
                          <FormControl className={classes.formControl}>
                            <Select
                              value={termFilter}
                              onChange={handleChangeFilter}
                              className={classes.formControl}
                              displayEmpty
                              name="term"
                            >
                              <MenuItem value="">
                                Session
                              </MenuItem>
                              {getTermOptions()}
                            </Select>
                          </FormControl>
                        </div>
                      </StyledTableCell>
                      <StyledTableCell align="">
                        <div className={classes.TableControl}>
                          {localizedStrings.students.degreePlan.status === "Status" 
                            ? "Statut" 
                            : localizedStrings.students.degreePlan.status}
                          <FormControl className={classes.formControl}>
                            <Select
                              value={statusesData}
                              onChange={handleChangeFilter}
                              className={classes.formControl}
                              displayEmpty
                              name="status"
                            >
                              <MenuItem value="">
                                {localizedStrings.students.degreePlan.status === "Status" 
                                  ? "Statut" 
                                  : localizedStrings.students.degreePlan.status}{" "}
                              </MenuItem>
                              {statusData}
                            </Select>
                          </FormControl>
                        </div>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.grade}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.creditsavailable}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.creditsearned}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.creditstype}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>{tableData}</TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  component="div"
                  count={filteredTableData.length > 0 ? filteredTableData.length : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  labelRowsPerPage={
                    <span style={{ textTransform: "none" }}>
                      {localizedStrings.rows.rowsperpage}
                    </span>
                  }
                  labelDisplayedRows={customLabelDisplayedRows}
                />
              </TableContainer>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Typography style={{ marginBottom: "1rem", paddingBottom: "1rem" }}>
                {language === "fr" 
                  ? "Un cours peut paraitre dans plus d'un \"groupe de matières pour le diplôme\" et dans certains cas répondre à plus d'une exigence. Par contre, les crédits de ce cours ne compteront qu'une seule fois envers le total de crédits exigés par ton programme."
                  : "A course may appear in more than one \"degree subject group\" and in some cases fulfill more than one requirement. However, the credits for this course will only count once towards the total credits required by your program."}
              </Typography>
              {groupCourses.map((courses) => {
                const isExpanded =
                  expanded[courses.ses_coursegroupname] || false;
                return (
                  <div key={courses.ses_coursegroupname}>
                    <Typography
                      component="h6"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <IconButton
                        onClick={() =>
                          toggleExpand(courses.ses_coursegroupname)
                        }
                      >
                        {isExpanded ? (
                          <RemoveIcon fontSize="large" />
                        ) : (
                          <AddIcon fontSize="large" />
                        )}
                      </IconButton>

                      <span style={{ fontWeight: "bold" }}>
                        {courses.ses_coursegroupname}
                      </span>
                    </Typography>
                     <Typography
                      style={{ marginLeft: "3.7rem" }}
                      component="div"
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: courses.ses_coursegroupdescription,
                        }}
                      />
                    </Typography>
                    <Typography style={{ marginLeft: "3.7rem" }}>
                      <span style={{ fontWeight: "bold" }}>
                        {localizedStrings.students.degreePlan.creditsrequired}
                      </span>{" "}
                      :{" "}
                      {
                        courses[
                          "ses_creditsrequired@OData.Community.Display.V1.FormattedValue"
                        ]
                      } 
                    </Typography>
                    {isExpanded && (
                      <>
                        <TableContainer
                          component={Paper}
                          style={{ minHeight: "46.5vh", marginBottom: "10px" }}
                        >
                          <Table aria-label="required degree course">
                            <TableHead>
                              <StyledTableRow>
                              <StyledTableCell align="left">
                                <div className={classes.TableControl}>
                                  {localizedStrings.students.degreePlan.course}
                                  <Input
                                    value={groupCourseFilter}
                                    onChange={handleGroupFilterChange}
                                    className={`${classes.formControl} ${classes.searchInput}`}
                                    displayEmpty
                                    name="groupCourse"
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <SearchIcon style={{ color: "#ffffff" }} />
                                      </InputAdornment>
                                    }
                                  />
                                </div>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <div className={classes.TableControl}>
                                  Session
                                  <FormControl className={classes.formControl}>
                                    <Select
                                      value={groupTermFilter}
                                      onChange={handleGroupFilterChange}
                                      className={classes.formControl}
                                      displayEmpty
                                      name="groupTerm"
                                    >
                                      <MenuItem value="">
                                        Session
                                      </MenuItem>
                                      {getTermOptions()}
                                    </Select>
                                  </FormControl>
                                </div>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <div className={classes.TableControl}>
                                  {localizedStrings.students.degreePlan.status === "Status" 
                                    ? "Statut" 
                                    : localizedStrings.students.degreePlan.status}
                                  <FormControl className={classes.formControl}>
                                    <Select
                                      value={groupStatusFilter}
                                      onChange={handleGroupFilterChange}
                                      className={classes.formControl}
                                      displayEmpty
                                      name="groupStatus"
                                    >
                                      <MenuItem value="">
                                        {localizedStrings.students.degreePlan.status === "Status"
                                          ? "Statut"
                                          : localizedStrings.students.degreePlan.status}
                                      </MenuItem>
                                      {groupStatusOptions()}
                                    </Select>
                                  </FormControl>
                                </div>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {localizedStrings.students.degreePlan.grade}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {
                                  localizedStrings.students.degreePlan
                                    .creditsavailable
                                }
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {
                                  localizedStrings.students.degreePlan
                                    .creditsearned
                                }
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {
                                  localizedStrings.students.degreePlan
                                    .creditstype
                                }
                              </StyledTableCell>
                              </StyledTableRow>
                            </TableHead>
                            {getFilteredGroupData(courses).length === 0 && (
                              <TableBody>
                                <div>No data available </div>
                              </TableBody>
                            )}
                            <TableBody>
                              {getFilteredGroupData(courses)
                                ?.sort((a, b) =>
                                  a.ses_course.localeCompare(b.ses_course),
                                )
                                .map((degreeCourse) => {
                                  return (
                                    <StyledTableRow>
                                      <StyledTableCell align="left">
                                        {degreeCourse.ses_course} - {degreeCourse.ses_coursename}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {degreeCourse["_ses_term_value@OData.Community.Display.V1.FormattedValue"] || ""}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {getLocalizedStatusLabel(
                                          degreeCourse.ses_studentsessionstatus,
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {degreeCourse["ses_gradereceived"]}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {
                                          degreeCourse[
                                            "ses_credits@OData.Community.Display.V1.FormattedValue"
                                          ]
                                        }
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {degreeCourse["ses_earnedcredits"] ===
                                        undefined
                                          ? ""
                                          : parseFloat(
                                                degreeCourse[
                                                  "ses_earnedcredits"
                                                ],
                                              ) === 0
                                            ? degreeCourse[
                                                "ses_earnedcredits@OData.Community.Display.V1.FormattedValue"
                                              ]
                                            : degreeCourse[
                                                  "ses_requirementmet"
                                                ] === true
                                              ? degreeCourse[
                                                  "ses_earnedcredits@OData.Community.Display.V1.FormattedValue"
                                                ]
                                              : "-"}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {translateCreditType(
                                          degreeCourse[
                                            "ses_credittype@OData.Community.Display.V1.FormattedValue"
                                          ]
                                        )}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    )}
                  </div>
                );
              })}
            </TabPanel>
          </>
        )}
        </div>
        
      )}
        </div>
    </Aux>
  );
};

export default withRouter(DegreePlan);
